import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const StateProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();
    
    const listRecords = useCallback(async () => {
        await execute({ scope: 'list', url: 'State?countryId=US', method: 'GET', secure: true });
    }, [execute]);  

    const listFranchiseStatesRecords = useCallback(async () => {
        await execute({ scope: 'list', url: 'State/Franchise?countryId=US', method: 'GET', secure: true });
    }, [execute]);  

    const value = { listRecords, listFranchiseStatesRecords, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useStateStore = () => React.useContext(Context);
